export default __webpack_public_path__ + "static/media/group.a4837110.svg";